var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{attrs:{"id":"project-estimate-role-tab"}},[_c('v-col',{attrs:{"xl":"12","lg":"12"}},[_c('ProjectEstimatesRoleTable',{attrs:{"items":_vm.estimationRoles,"allowed":_vm.allowed}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }